<template>
  <div class="conversation-actions">
    <div
      v-if="
        currentAgency &&
        currentConversation.status == 'active' &&
        activeVideoRoom &&
        activeVideoRoom.status === 'in-progress'
      "
      class="px-3 py-2 border-top"
    >
      <VideoRoom :roomId="activeVideoRoom.room_id" />
    </div>
    <div
      v-if="
        currentConversation.channel != 'media' &&
        currentConversation.status == 'active' &&
        currentConversation.recipients &&
        currentConversation.recipients.length > 0
      "
    >
      <LocationWidget
        :recipientId="currentConversation.recipients[0].recipient_id"
        :recipientLabel="currentConversation.recipients[0].number"
        :conversationId="currentConversation.conversation_id"
      />
    </div>
    <div v-if="showInterpreter" class="px-3 py-2 border-top">
      <ConnectWithInterpreter />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { EventBus } from "@/events/eventBus";
import LocationWidget from "../widgets/LocationWidget";
import VideoRoom from "../VideoRoom";
import MessageTemplates from "./MessageTemplates";
import ConnectWithInterpreter from "./ConnectWithInterpreter.vue";

export default {
  name: "ConversationActions",
  components: {
    LocationWidget,
    VideoRoom,
    MessageTemplates,
    ConnectWithInterpreter,
  },
  props: {
    currentRecipientLang: String,
    conversationId: String,
  },
  data() {
    return {
      showInterpreter: false,
    }
  },
  create() {
    this.showInterpreter = false;

    EventBus.$on('toggle-interpreter-sdk', (conversationId) => {
      if (conversationId === this.conversationId) {
        this.showInterpreter = !this.showInterpreter;
      }
    });
  },
  computed: {
    ...mapGetters("agency", ["currentAgency", "agencySettings", "isSDKEnabled"]),
    ...mapGetters("conversations", ["currentConversation", "conversationStatus"]),
    ...mapGetters("video", ["videoRooms"]),
    ...mapGetters("user", ["currentUser"]),
    activeVideoRoom() {
      if (this.videoRooms && this.videoRooms.length > 0) {
        const activeVideoRoom = this.videoRooms.find(room => room.conversation_id == this.conversationId);
        if (activeVideoRoom && activeVideoRoom.status == "in-progress")
          return activeVideoRoom;
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.conversation-actions {
  width: 100%;
}
</style>
